import { render, staticRenderFns } from "./doctorConfirm.vue?vue&type=template&id=a497ffa2&scoped=true&"
import script from "./doctorConfirm.vue?vue&type=script&lang=js&"
export * from "./doctorConfirm.vue?vue&type=script&lang=js&"
import style0 from "./doctorConfirm.vue?vue&type=style&index=0&id=a497ffa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a497ffa2",
  null
  
)

export default component.exports